module.exports = "/_next/static/images/bffa23c8b29138d9901c5a250fe79ef1-man-holding-device-2@3x.jpg.webp";